import React, { useEffect, useState } from "react";
import "../../../../../css/CashflowModeller2/Inputs/Inputs.css";
import "../../../../../css/CashflowModeller2/Inputs/InputSmall.css";
import { useFormattedNumber } from "../../Hooks/UseFormattedNumber";

/**
 * InputSmall is a controlled input component for numeric values with optional formatting for currency or percentage.
 */
const InputSmall = ({
  isDisabled,
  type = "number", // allow "percent" too
  label,
  value,
  per, // keep existing prop
  currency = false,
  onChange,
  readOnly,
  isError,
  placeholderText,
}) => {
  const [status, setStatus] = useState("default");
  const [isFocused, setIsFocused] = useState(false);

  // treat type="percent" the same as per={true}
  const isPercent = per || type === "percent";

  const cleanValue = (val) => (val ?? "").replace(/[^0-9.]/g, "");
  const { rawValue, formattedValue, handleChange } = useFormattedNumber(
    cleanValue(value || ""),
    type === "percent" ? "number" : type
  );

  const [internalValue, setInternalValue] = useState(formattedValue);

  // Only resync from prop when not focused, and keep the visible symbol
  useEffect(() => {
    if (isFocused) return;
    let v = formattedValue || "";
    if (v) {
      if (isPercent && !String(v).endsWith("%")) v = `${v}%`;
      else if (currency && !String(v).startsWith("£")) v = `£${v}`;
    }
    setInternalValue(v);
  }, [formattedValue, isFocused, isPercent, currency]);

  const handleLocalChange = (e) => {
    const raw = cleanValue(e.target.value);
    if ((raw.match(/\./g) || []).length > 1) return;
    setInternalValue(raw);
    onChange?.(raw);
  };

  const handleFocus = () => {
    if (readOnly) return;
    setStatus("selected");
    setIsFocused(true);
    setInternalValue(cleanValue(String(internalValue)));
  };

  const handleBlur = () => {
    setStatus("default");
    setIsFocused(false);
    let formatted = internalValue;
    if (formatted && formatted.length > 0) {
      if (isPercent) formatted = `${formatted}%`;
      else if (currency) formatted = `£${formatted}`;
    }
    setInternalValue(formatted);
  };

  return (
    <div className={`${label ? "input-small input-label-container" : ""}`}>
      {label && (
        <div className="Label" style={{ textAlign: "center" }}>
          {label}
        </div>
      )}
      <div
        className={`input-container ${isDisabled ? "disabled" : ""} ${status} ${
          isError ? "error" : ""
        } ${readOnly ? "readOnly" : ""}`}
      >
        <input
          type="text"
          inputMode="decimal"
          value={internalValue || ""}
          placeholder={placeholderText ?? 65}
          onChange={readOnly ? () => {} : handleLocalChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={`input-small input-field Input ${
            isDisabled ? "disabled" : ""
          }`}
          disabled={isDisabled}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
};

export default InputSmall;
